<script setup></script>

<template>
  <img
    src="@/assets/images/icons/logistic-postat.png"
    srcset="@/assets/images/icons/logistic-postat.png"
    :alt="$t('logisticpartners.post-at')"
  />
</template>
